<template>
    <li  v-if="notification.item" :class="{'read': notification.item.read_at}">
        <div class="notification__content">
            <small>{{ notification.item.created_at | moment }}</small>
            <a href="#" @click="handleNotification" v-if="notification.item">
                {{notification.message}}    
            </a>
            <div v-else>
                {{notification.message}}  
            </div>
            
        </div>
        
        <div class="notification__actions">
            <span  v-if="this.$store.getters['user/isElevated']"><i class="material-icons markasread" :class="{'read': notification.item.read_at}" @click="markAsRead">check</i></span>
            <span  v-if="this.$store.getters['user/isElevated']"><i class="material-icons remove" @click="remove">clear</i></span>
            <span  v-if="this.$store.getters['user/isFreelancer']"><i class="material-icons remove_red_eye" @click="handleNotification">remove_red_eye</i></span>
        </div>
    </li>
</template>

<script>
    import moment from "moment";
    import accountPerimeter from '@/permissions/accountPerimeter';
    export default {
        props: ['item', 'idx'],
        filters: {
            moment: function (date) {
                return moment(date).format('DD-MM-YYYY HH:MM');
            }
        },
        computed: {
            notification(){
                switch (this.item.type) {
                    
                    // ignore
                    case "Zorgbord\\Notifications\\ShiftInterestedNotification":
                    case "Zorgbord\\Notifications\\ShiftDeniedNotification":
                    case "Zorgbord\\Notifications\\ZorgbordInvoiceGenerated":
                    case "Zorgbord\\Notifications\\AdminShiftCancelledNotification":
                    case "Zorgbord\\Notifications\\NewOpenShift":
                    case "Zorgbord\\Notifications\\UrgentShift":    
                        return {
                            type: 'noop',
                            message: 'No-Operation',
                            item: false,
                        };
                        break;

                    case "Zorgbord\\Notifications\\FreelancerInvoiceGenerated":
                        return {
                            type: 'invoice_created',
                            message: `Factuur #${this.item.data.invoice_id} aangemaakt`,
                            item: this.item,
                        };
                        break;
                    case "Zorgbord\\Notifications\\FreelancerInvoiceFailed":
                        return {
                            type: 'invoice_failed',
                            message: `Factuur #${this.item.data.invoice_id} mislukt`,
                        };
                        break;
                    case "Zorgbord\\Notifications\\ShiftCancelledNotification":
                    return {
                            type: 'shift_cancelled',
                            message: `De dienst ${this.item.data.company}\\${this.item.data.department} op ${moment(this.item.data.start_datetime).format('DD-MM-YYYY HH:mm')} is geannuleerd.`,
                            item: this.item
                        };
                        break;
                    case "Zorgbord\\Notifications\\ShiftInvitationNotification":
                        return {
                            type: 'shift_invited',
                            message: `U bent uitgenodigd voor een dienst bij ${this.item.data.department} op ${moment(this.item.data.start_datetime).format('DD-MM-YYYY HH:mm')}`,
                            item: this.item
                        };
                        break;
                     case "Zorgbord\\Notifications\\ShiftAcceptedNotification":
                        return {
                            type: 'shift_invited',
                            message: `U bent geaccepteerd voor een dienst bij ${this.item.data.department} op ${moment(this.item.data.start_datetime).format('DD-MM-YYYY HH:mm')}`,
                            item: this.item
                        };
                        break;    
                    case "Zorgbord\\Notifications\\InvitedUserIsInterested":
                        return {
                            type: 'user_interested',
                            message: 'Uitgenodigde zorgverlener is geintereseerd',
                            item: this.item
                        };
                        break;
                    case "Zorgbord\\Notifications\\NewUserRegistered":
                        return {
                            type: 'user_registered',
                            message: 'Nieuwe gebruiker geregistreerd',
                            item: this.item
                        };
                        break;
                    case "Zorgbord\\Notifications\\NewCompanyRegistered":
                        return {
                            type: 'company_registered',
                            message: 'Nieuw bedrijf geregistreerd',
                        };
                        break;
                    case "Zorgbord\\Notifications\\ShiftAcceptedNotification":
                        return {
                            type: 'shift_accepted',
                            message: 'Er is een dienst geaccepteerd',
                            item: this.item
                        };
                        break;
                    default:
                        return {
                            type: 'default_message',
                            message: 'Standaard bericht : '+this.item.type,
                            item: this.item
                        };
                        break;
                }
            }
        },
        methods: {
            handleNotification(){
                if(this.notification.type === 'shift_invited' || this.notification.type === 'shift_accepted' ){
                    let date = moment(this.notification.item.data.start_datetime).format('YYYY-MM-DD');
                    this.$router.push({ name: 'dashboard', query: { 'start_datetime': date, 'shift_id': this.notification.item.data.shift_id }});
                }
                if(this.notification.type === 'invoice_created'){
                    this.$router.push({ name: 'userinvoices'});
                }
                if(this.notification.type === 'user_registered'){
                    this.$router.push({ path: `/profile/${this.notification.item.data.user_id}`})
                }

                // MARK AS READ IF IS NOT ALREADY
                if(this.notification.item && this.notification.item.read_at === null){
                    this.markAsRead()
                }
            },
            async markAsRead(bool){
                try {
                    let read = await this.$axios.patch(`/users/notifications/${this.item.id}/read`);
                    this.$emit('update', {
                        item: read.data,
                        idx: this.idx
                    });
                } catch (e) {
                    this.displayErrors(e.response.data.errors);
                }
            },
            async remove(){
                try {
                    let remove = await this.$axios.delete(`/users/notifications/${this.item.id}`);
                    this.$emit('remove', this.idx);
                } catch (e) {

                    this.displayErrors(e.response.data.errors);
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/notification-item.vue